/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{ useState,useEffect } from "react";
import { Link } from "react-router-dom"; 
import axios from 'axios';
import { ChangeMobileFormat } from "../../components/common/Common";

const CompanyInfo = () => {

  //서비스기업 정보 저장 객체
  const [varCompanyInfo,setCompanyInfo] = useState({});

  //서비스 정보 호출
  const GetServiceStatus = async() => {
    await axios.post(`${process.env.REACT_APP_HOST}/_get_service_status`).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setCompanyInfo(datas.environment);
      }
    });
  }

  useEffect(() => {
    GetServiceStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <footer id="footer" style={{marginBottom:"84px",width:"100%"}}>
      <div className="footer-info">
        <ul>
          <li>
            <Link to={`/Conditions/1`}>이용약관</Link><span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <Link to={`/Conditions/2`}>개인정보처리방침</Link>
          </li>
          <li>법인명&nbsp;&nbsp;|&nbsp;&nbsp;{varCompanyInfo.company_name}</li>
          <li>사업자 등록번호&nbsp;&nbsp;|&nbsp;&nbsp;{varCompanyInfo.bizcode}</li>
          <li>주소: {varCompanyInfo.address1+" "+varCompanyInfo.address2}</li>
          <li><a href={`tel:${varCompanyInfo.telephone}`}>고객센터&nbsp;&nbsp;|&nbsp;&nbsp;{ChangeMobileFormat(varCompanyInfo.telephone)}</a></li>
          <li>Copyright 2023 All right reserved.</li>
        </ul>
      </div>
    </footer>
  );
}
export default CompanyInfo;